import angular from 'angular';
import whatIsSolidayEuroFooterComponent from './whatIsSolidayEuroFooter.component';

let whatIsSolidayEuroFooterModule = angular.module('whatIsSolidayEuroFooter', [
])

.component('whatIsSolidayEuroFooter', whatIsSolidayEuroFooterComponent)

.name;

export default whatIsSolidayEuroFooterModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidayEuroFooter/whatIsSolidayEuroFooter.js